import { Reveal, Overline } from "@/components/Reveal";

const AUTHORITY_IMG = "https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxleGVjdXRpdmUlMjBtZWV0aW5nJTIwZGFya3xlbnwwfHx8fDE3ODM0MzA5Mjh8MA&ixlib=rb-4.1.0&q=85";

const TEAM = [
  { name: "Dirección de expansión", role: "Estrategia de franquicias", desc: "Diseño del modelo de territorios y la estructura de licencias para Latinoamérica." },
  { name: "Adquisición y datos", role: "Meta Ads & performance", desc: "Gestión centralizada de la pauta y optimización constante del costo por cliente." },
  { name: "Tecnología y producto", role: "Plataforma & CRM", desc: "Mantenimiento del stack digital que opera cada franquicia sin fricción." },
];

export function Authority() {
  return (
    <section id="authority" data-testid="authority-section" className="relative py-24 sm:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <Reveal className="lg:col-span-5">
            <div className="relative">
              <img src={AUTHORITY_IMG} alt="Equipo directivo" className="w-full h-[560px] object-cover" />
              <div className="absolute inset-0 ring-1 ring-inset ring-midnight/10" />
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/60 via-transparent to-transparent" />
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <Reveal>
              <Overline>Respaldo y autoridad</Overline>
              <h2 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.05]">
                Un equipo que ya construyó la máquina. Usted la opera.
              </h2>
              <p className="font-sans text-lg font-light text-midnight/60 mt-6 max-w-2xl">
                Kairós Learning nace de operadores de educación digital y performance marketing.
                La franquicia no es un experimento: es un sistema probado que centralizamos para que
                usted no reinvente nada.
              </p>
            </Reveal>

            <div className="mt-10 space-y-px bg-midnight/10 border border-midnight/10">
              {TEAM.map((t, i) => (
                <Reveal key={t.name} delay={i * 0.1} className="bg-white">
                  <div className="p-6 lg:p-7">
                    <div className="flex items-baseline justify-between gap-4 flex-wrap">
                      <h3 className="font-serif text-xl font-semibold text-midnight">{t.name}</h3>
                      <span className="font-sans text-xs uppercase tracking-wider text-crimson font-bold">{t.role}</span>
                    </div>
                    <p className="font-sans text-sm font-light text-midnight/60 mt-2 leading-relaxed">{t.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
